<app-modal
  [isOpen]="true"
  [title]="'Historial de la muestra'"
  [width]="70"
  [height]="85"
  (closeModal)="onClose()"
>
  <div class="version-history-wrapper flex flex-col gap-4">
    <!-- Case Info Header -->
    <div class="case-info-grid">
      <div class="info-item">
        <span class="info-label">Paciente:</span>
        <span class="info-value">{{ getPatientFullName() }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Documento:</span>
        <span class="info-value"
          >{{ caseItem().identificationType }}
          {{ caseItem().identificationNumber }}</span
        >
      </div>
      <div class="info-item">
        <span class="info-label">Código LG:</span>
        <span class="info-value">{{ caseItem().lgNumber || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Código Sura:</span>
        <span class="info-value">{{ caseItem().caseNumber || '-' }}</span>
      </div>
    </div>

    <!-- Loading State -->
    @if (isLoading()) {
      <div
        class="loading-state flex flex-col items-center justify-center py-12"
      >
        <div class="loading-spinner mb-3"></div>
        <span class="text-text-secondary">Cargando historial...</span>
      </div>
    }

    <!-- Error State -->
    @else if (error()) {
      <div class="error-state flex flex-col items-center justify-center py-12">
        <i class="icon-alert-circle text-4xl text-error mb-3"></i>
        <span class="text-text-secondary">{{ error() }}</span>
      </div>
    } @else if (historyVersions().length === 0) {
      <div class="empty-state flex flex-col items-center justify-center py-12">
        <i class="icon-documento text-4xl text-text-tertiary mb-3"></i>
        <span class="text-text-secondary">No se encontraron registros</span>
      </div>
    } @else {
      <div class="versions-list flex flex-col gap-3">
        @for (
          version of historyVersions();
          track version.version;
          let i = $index
        ) {
          <div
            class="version-entry-card"
            [class.collapsed]="collapsedVersions.has(i)"
          >
            <div class="version-header" (click)="toggleCollapse(i)">
              <div class="version-meta">
                <div class="version-date">
                  <i class="icon-calendar"></i
                  >{{ version.date | date: 'dd/MM/yyyy hh:mm a' }}
                </div>
                <div class="version-status">
                  {{ getStatusFromChanges(version.changes, version) }}
                </div>
                <div class="version-user">
                  <i class="icon-usuario"></i>{{ version.user }}
                </div>
              </div>
              <button
                class="collapse-btn"
                type="button"
                [attr.aria-expanded]="!collapsedVersions.has(i)"
              >
                <i
                  class="pi"
                  [class.pi-chevron-down]="collapsedVersions.has(i)"
                  [class.pi-chevron-up]="!collapsedVersions.has(i)"
                ></i>
              </button>
            </div>

            @if (!collapsedVersions.has(i)) {
              <div class="version-changes">
                @for (change of version.changes; track change.field) {
                  @if (change.field === 'Acción') {
                    <div class="action-row">
                      <span class="change-label">{{ change.field }}:</span>
                      <span class="change-value">{{ change.newValue }}</span>
                    </div>
                  }
                }

                <div class="changes-grid">
                  @for (change of version.changes; track change.field) {
                    @if (
                      change.field !== 'Acción' && change.field !== 'Estado'
                    ) {
                      <div class="change-item">
                        <span class="change-label">{{ change.field }}:</span>
                        @if (change.oldValue && change.newValue) {
                          <span class="change-value">
                            <span class="old-val">{{ change.oldValue }}</span>
                            <span class="arrow">→</span>
                            <span class="new-val">{{ change.newValue }}</span>
                          </span>
                        } @else if (change.newValue) {
                          <span class="change-value">{{
                            change.newValue
                          }}</span>
                        } @else if (change.oldValue) {
                          <span class="change-value old-val">{{
                            change.oldValue
                          }}</span>
                        }
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</app-modal>
